import { googleAnalyticsApis, otelApi } from 'Api/index'
// import GA_MAP, { pathMap, UserMap, getEventByRequest } from "./GoogleAnalyticsMap/index";
import { store } from 'Store/store.index'
import { USER_SIGN_IN_SUCCESS } from "Store/constants";
import { prop } from '@/utils/utils';

export class UserBehaviorTrackingService {
    constructor() {
      this.signInSuccessSpan = null
      this.onUserSignInSuccessForJaeger();
    }
    loadingGA(){
        return import("./GoogleAnalyticsMap/index")
    }
    initStore() {
      return new Promise((resolve) => {
        let flag = setInterval(() => {
          if (store) {
            clearInterval(flag);
            resolve();
          }
        }, 0);
      });
    }
    async onUserSignInSuccessForJaeger() {
        await this.initStore().catch((error) => {
          console.error(error)
        })
        const { appEventEmitter } = store.appStore;
        const onSendJaegerData = async () => {
          let apps;
          let extraInformation;
          let plan_expires_in = '';
          const { full_name: username } = store.userStore.userInfo;
          const { accountStore } = store;

          if (accountStore && accountStore.apps && accountStore.apps.length) {
            apps = accountStore.apps;
            plan_expires_in = apps[0].expiredDate;
          }

          extraInformation = {
            _group3: 'activities',
            username,
            plan_expires_in,
            industry: '',
            respresentative: '',
            location: '',
          };

          this.signInSuccessSpan =  await otelApi.sendJaegerData({ spanName: 'sign_in_out_duration', operationName: 'sign_in_out_duration', extraInformation, isReturnSpan: true });

          otelApi.sendJaegerData({ spanName: 'login', operationName: 'login', category:'event', extraInformation})
        };

        appEventEmitter.removeListener(USER_SIGN_IN_SUCCESS, onSendJaegerData)
        appEventEmitter.on(USER_SIGN_IN_SUCCESS, onSendJaegerData)
    }
    doSendNPSData({action, extraInformation, channel = 'Foxit Editor Cloud'}){
      otelApi.sendJaegerData({ 
        spanName: action,
        operationName: action, 
        extraInformation, 
        surveyid: 'nps', 
        channel,
      })
    }
    doSendJaegerData(category, label, action,extraInformation) {
        let jaegerCategory
        
        if (category === 'CAS' || category === 'Subscription') {
            jaegerCategory = 'activities'
        } else if(category === 'Foxit Sign' || category === 'eSign' || category === 'Conversion_Improvement' || this.isEventAction(action)) {
          jaegerCategory = 'event'
        } else if (label === 'Event' || label === 'Property') {
            jaegerCategory = 'logs'
        } else {
            jaegerCategory = 'functions'
        }

        if (action === 'exit' && this.signInSuccessSpan) {
            this.signInSuccessSpan.end()
        }

        otelApi.sendJaegerData({ spanName: action, operationName: action, extraInformation:!!extraInformation?extraInformation:'', category: jaegerCategory, label: label })
    }
    isEventAction(action) {
      return [
        'Install_Button_Clicks',
        'Install_Button_PWA_Install',
        'Install_Button_Package_Download'
      ].includes(action);
    }
    doSetUserId(id) {
        googleAnalyticsApis.setUserId(id)
    }
    // tabName: "home" "file" "convert" "edit" "organize" "comment" "protect" "form"
    // tabName => label
    doSendGAEvent({ eventKey, label, value, category, action }) {
        setTimeout(()=>{
            this.loadingGA()
            .then(module=>{
                const GA_MAP =module.default;
                store.appStore.doSaveAction(eventKey);
                if (!label) return;
        
                let eventValue;
                if (category && action) {
                eventValue = {category, action};
                }
                if (!eventValue) {
                do {
                    let tab_map = GA_MAP[label];
                    if (!tab_map) break;
                    eventValue = tab_map[eventKey];
                } while (false)
                }
                if (!eventValue) {
                    if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEvent -> eventKey: ${eventKey}, can not found label`)
                    return
                }
                const { category: _category, action: _action } = eventValue;
                //category = 'The new PhantomPDF Online'; // CAS
                //if(!action) action = label;
                if (label === 'doc_event') label = 'Event';
                
                googleAnalyticsApis.jRsRgaSend(label, _category, _action, value)
        
                this.doSendJaegerData(_category, label, _action);
        })
        },200)
        
    }
    doSendGAEventByRequest(type, status) {
        this.loadingGA()
        .then(module=>{
            let value = module.getEventByRequest(status, type);
            if (!value) {
                if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEventByRequest -> type: ${type}, status: ${status}, can not found label`)
                return
            }
            
            const { category, action } = value;
            googleAnalyticsApis.jRsRgaSend('Event', category, action)
            store.appStore.doSaveAction(action);
        })
    }

    doSendGAEventByUser({ eventKey, label, param, extraInformation }) {
        this.loadingGA()
        .then(module=>{
            const {pathMap,UserMap} = module
            store.appStore.doSaveAction(eventKey);
            
            // let extraInformation
            let pathName = prop(location, 'pathname');
            let eventLabel = label
            let pre = pathMap[pathName];
            if (!pre) {
                if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEventByUser -> eventKey: ${eventKey}, label: ${label}, can not found page map`)
                return;
            }
            let eventValue;
            do {
                let subMap = UserMap[label];
                if (!subMap) break;
                eventValue = subMap[eventKey];
            } while (false)
            if (!eventValue) {
                if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEventByUser -> eventKey: ${eventKey}, label: ${label}, can not found label`)
                return
            }
            label = pre + label;
            const { category, action } = eventValue;
            let fullAction = param ? action + '_with_' + param : action;

            
            googleAnalyticsApis.jRsRgaSend(label, category, fullAction)

            this.doSendJaegerData(category, eventLabel, action,extraInformation)
        })
    }

    doSendGAEventByUserEvent(eventKey, addedValue, callback) {
        this.loadingGA()
        .then(module=>{
            const GA_MAP = module.default
            store.appStore.doSaveAction(eventKey);
            let subMap = GA_MAP['user_event']
            let value = subMap[eventKey];
            if (!value) {
                if(process.env.NODE_ENV == 'development')console.warn(`TCL: doSendGAEventByUserEvent -> eventKey: ${eventKey}, label: user_event, can not found label`)
                return
            }
            const { category, action } = value;
            let curAction = action;
            if (addedValue) {
                curAction = action + addedValue;
            }
            
            return googleAnalyticsApis.jRsRgaSend('Event', category, curAction).then(() => {
                callback && callback()
            })
        });
    }
}